export const validationRules = {
  firstName: ['required'],
  lastName: ['required'],
  address1: ['required'],
  postalCode: ['required', 'len-5'],
  city: ['required', 'lt-23'],
  stateCode: ['required', 'validState'],
  cellPhone: ['gt-9', 'lt-13'],
  workPhone: ['required', 'gt-9', 'lt-13'],
};

export const onTypeRules = {
  firstName: ['name'],
  lastName: ['name'],
  postalCode: ['numeric'],
  city: ['specialChars'],
  stateCode: ['specialChars', 'letters'],
  workPhoneExt: ['numeric'],
};
